import { FC } from 'react'
import cx from 'classnames'

import { ButtonsProps } from '../Buttons'

import * as SC from './styled'

export type PublicationGuideBigCardProps = {
  className?: string
  title: string
  text: string
  buttons: ButtonsProps
}

const PublicationGuideBigCard: FC<PublicationGuideBigCardProps> = ({
  className,
  title,
  text,
  buttons,
}) => {
  return (
    <SC.PublicationGuideBigCard
      className={cx('PublicationGuideBigCard', className)}
    >
      <SC.Title>{title}</SC.Title>
      <SC.Separator />
      <SC.Wrapper>
        <SC.Text>{text}</SC.Text>
        <SC.Btn {...buttons} />
      </SC.Wrapper>
    </SC.PublicationGuideBigCard>
  )
}

export default PublicationGuideBigCard
